function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { getRowTextValue } from "../../../utils/product/getRowTextValue";
import { context } from "../../../components/wr-context";
import { tagReplacer2 } from "../../../utils/proposals/tag-replacer";
import formatDate from "../../../utils/format-date";
import { replaceTagsFromMap } from "./replaceTagsFromMap";
export var quickReplaceTags = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        customTags: [],
        customTagsWithValue: {}
    };
    var defaultQuickReplaceFields = [
        "companyName",
        "companyAddress",
        "startDate",
        "saasFee",
        "discountPercent",
        "implementationDate", 
    ];
    var defaultQuickReplaceFieldsWithValue = {
        currentDate: formatDate()(new Date())
    };
    var tags = _toConsumableArray(defaultQuickReplaceFields).concat(_toConsumableArray(options.customTags));
    var tagsWithValue = _objectSpread({}, defaultQuickReplaceFieldsWithValue, options.customTagsWithValue);
    return function(ctx) {
        ctx.html = replaceTagsFromMap(ctx.html, tagsWithValue);
        context.state.cart.forEach(function(item) {
            item.rows.forEach(function(row) {
                var _options;
                var tag = ((_options = row.options) !== null && _options !== void 0 ? _options : {}).tag;
                if (!tag || !tags.includes(tag)) {
                    return;
                }
                var rowValue = item.values[row.id];
                ctx.html = tagReplacer2(ctx.html, tag, getRowTextValue(rowValue));
            });
        });
    };
};
